import { initializeApp } from 'firebase/app';

import {
  getAuth,
  onAuthStateChanged,
  getRedirectResult,
  signInWithEmailAndPassword,
  signOut
} from 'firebase/auth';

import {
  getDatabase,
  ref,
  set,
  update,
  onValue,
  onChildAdded,
  onChildChanged,
  onChildRemoved,
  get,
  child,
  push
} from "firebase/database";

import {
  getFirestore,
  collection,
  addDoc
} from "firebase/firestore";


import moment from 'moment-timezone';

import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDyfnTRLG8XEDNc5U2Hm75kRpMPIsMpmGE", //TODO - move credentials to a .env file
  authDomain: "esporter-ea545.firebaseapp.com",
  databaseURL: "https://esporter-ea545-default-rtdb.firebaseio.com",
  projectId: "esporter-ea545",
  storageBucket: "esporter-ea545.appspot.com",
  messagingSenderId: "80717931299",
  appId: "1:80717931299:web:43a7091680991dd5ce2296",
  measurementId: "G-LTED9H5H86"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth();
const database = getDatabase(app);
const firestore_db = getFirestore(app);

/* Notifications implementation in progress below ... */
// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
//const messaging = getMessaging();
/* getToken(messaging, { vapidKey: 'BIAszeqxStAfjoWe3vRKwIhpylOT6pgsk3gL1npaVDMKIHGyd68Xrk76zbeY8SBogn9n6oJK8GyzsSSvEPE7e8o' }).then((currentToken) => {
  if (currentToken) {
    // Send the token to your server and update the UI if necessary
    // ...
    // TODO - set the token in the database of the user, make the user token part of the database only accessible by the service worker
  } else {
    // Show permission request UI
    console.log('No registration token available. Request permission to generate one.');
    // ...
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  // ...
});*/


var user = auth.currentUser;

export function createRecording(recording: any, callback: any) {

  const newRecordingKey = push(child(ref(database), '/recordings/')).key;

  recording.id = newRecordingKey;

  const updates: any = {};

  var result:any;

  updates['/recordings/' + newRecordingKey] = recording;

  update(ref(database), updates).then((res) => {
    result = res;
    callback(recording);
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export function updateRecording(recording: any, callback: any) {

  const updates: any = {};
  updates['/recordings/' + recording.id] = recording;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
    callback();
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export const readRecordings = (callback: any) => {
  const recordingsRef = ref(database, 'recordings');

  onValue(recordingsRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export const readMatches = (callback: any) => {
  const matchesRef = ref(database, 'matches');

  onValue(matchesRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export const readUsersWithRecords = (callback: any) => {

  /*

      var splits:any = {};

      get(splitsRef).then((splitsSnapshot)=>{
        splits = splitsSnapshot.val();
      });

      for (var uid in users){
        if (users[uid].matches){
          for (var mid in users[uid].matches){
            if (users[uid].matches[mid]){
              for (var sid in splits){
                if (splits[sid].status != "closed"){
                  if (splits[sid].matches){
                    if (splits[sid].matches[mid]){
                      var matchRef = ref(database, 'matches/'+match);
                      get(matchRef).then((matchSnapshot)=>{

                      });
                    }
                  }
                }
              }
            }
          }
        }
      }

  */

  const usersRef = ref(database, 'users');

  onValue(usersRef, (usersSnapshot) => {

    var users:any = usersSnapshot.val();
    var userCount:any = 0;

    const splitsRef = ref(database, 'splits');

    onValue(splitsRef, (splitsSnapshot)=>{
      const splits = splitsSnapshot.val();

      for (var uid in users){
        userCount++;
        if (users[uid]){
          if (users[uid].matches){
            var matchCount:any = 0;

            if (users[uid].matches && Object.keys(users[uid].matches).length){
              for (var match in users[uid].matches){
                matchCount++;

                if (match) {

                  if (users[uid].matches[match]){

                    var splitsCount: any = 0;
                    for(var split in splits){
                      splitsCount++;
                      if (splits[split].matches){
                        if (splits[split].status != "closed"){
                          if (splits[split].matches[match]){

                            const matchRef = ref(database, 'matches/'+match);

                            onValue(matchRef, (matchSnapshot)=>{
                              console.log("Reading Matches");
                              var playerWon: boolean = true;
                              if (users[uid]){
                                if (matchSnapshot.val().status == "done"){
                                    for (var player in matchSnapshot.val().players[uid].score){
                                      if (matchSnapshot.val().players[uid].score[uid] < matchSnapshot.val().players[uid].score[player]){
                                        playerWon = false;
                                      }
                                    }

                                    if (!users[uid].scores){
                                      users[uid].scores = {};
                                    }
                                    if (!users[uid].scores[splits[split].splitId]){
                                      users[uid].scores[splits[split].splitId] = {
                                        wins: 0,
                                        losses: 0,
                                        total: 0
                                      };
                                    }

                                    if (playerWon){
                                      users[uid].scores[splits[split].splitId].wins = users[uid].scores[splits[split].splitId].wins + 1;
                                    }
                                    else {
                                      users[uid].scores[splits[split].splitId].losses = users[uid].scores[splits[split].splitId].losses + 1;
                                    }
                                    users[uid].scores[splits[split].splitId].total = users[uid].scores[splits[split].splitId].total + 1;
                                  }
                                  else {
                                    console.log("Didn't Find any matches");
                                  }
                              }

                              if (userCount == Object.keys(users).length && matchCount == Object.keys(users[uid].matches).length && splitsCount == Object.keys(splits).length){
                                callback(users);
                              }

                            });
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            else {
              if (userCount == Object.keys(users).length && matchCount == Object.keys(users[uid].matches).length && splitsCount == Object.keys(splits).length){
                callback(users);
              }
            }
          }
        }
      }
    });
  });
};

export function createSplit(split: any, callback: any) {

  const newSplitKey = push(child(ref(database), '/splits/')).key;

  split.splitId = newSplitKey;

  const updates: any = {};

  var result:any;

  readAllUsers((u:any)=>{

    for (var i=0; i<u.length; i++){
      if (u[i].public && u[i].public.games){
        if (u[i].public.games[split.gameName]){
          split.players[u[i].userId] = true;
        }
      }
    }

    updates['/splits/' + newSplitKey] = split;

    update(ref(database), updates).then((res) => {
      result = res;
      callback(split);
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });
  });

  return result;
};

export function updateSplit(split: any, callback: any) {

  const updates: any = {};
  updates['/splits/' + split.splitId] = split;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
    callback();
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export const readSplits = (callback: any) => {
  const splitsRef = ref(database, 'splits');

  onValue(splitsRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export function undoArchiveUser(userId: any, callback: any) {

  const updates: any = {};
  updates['/users/' + userId + '/isArchived'] = false;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
    callback();
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export function archiveUser(userId: any, callback: any) {

  const updates: any = {};
  updates['/users/' + userId + '/isArchived'] = true;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
    callback();
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export function writeGame(game: any, callback: any) {

  const updates: any = {};
  updates['/games/' + game.name] = game;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
    callback();
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export const setUserMetadata = (user: any) => {

    const updates: any = {};
    updates['/users/' + user.uid + '/createdAt'] = user.metadata.createdAt;
    updates['/users/' + user.uid + '/lastLoginAt'] = user.metadata.lastLoginAt;

    var result:any;

    console.log(user);

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
}

export const readAllUsers = (callback: any) => {
  return new Promise<any>(function (resolve, reject) {
    const usersRef = ref(database, 'users');

    onValue(usersRef, (snapshot) => {
      var users: any[] = [];
      snapshot.forEach((childSnapshot) => {
        users.push(childSnapshot.val());
      });
      callback(users);
      resolve(null);
    }, {
      //onlyOnce: true
    });
  });
};

export const writeInitialCosmetics = (userId: string) => {

    const updates: any = {};
    updates['/users/' + userId + '/restricted/cosmetics'] = {
      banners: {
        "-NMI7WEYoXWQ1Mt5_EW0": true,
        "-NMI9imMLqT8gFci-Msy": true,
        "-NMIK0vYtngfifLrz5QV": false,
        "-NMIK3g46HVy95ZYblD2": true,
        "-NMIK7flMKzuXVm2j4L4": false,
        "-NMIKBn1nTi9QU8zcUlh": true,
        "-NMIKIJ4uSyNdtR_stot": true
      },
      borders: {
        "-NMX0NlRlAhSMvf5a22a": true,
        "-NMX0SrXuJFEjeuA8Jpj": false,
        "-NMX0qwplPlDkTP1J3dA": false,
        "-NMX0xljLryd3rEDQGT2": true,
        "-NMX12N0mdStFiiyA6AG": true,
        "-NMX175QXqqorf6KUkMp": true,
        "-NMX1C6_DvApy7SfDVjS": true,
        "-NMX1Gfia1jzvubPnQ_p": true,
        "-NMX1MyBs8oHG7dNh3QB": true,
        "-NMX1StmLMAP_qM3vYMB": false,
        "-NMX1XB8iD-ePmeXIcrB": true
      },
      pictures: {
        "-NMWrnXshWqvIKcfrz11": false,
        "-NMWrwbmkoMe74UwyvNQ": true,
        "-NMWs0o3EVs7a5WJp2SE": true,
        "-NMWs53y6yTD2KqtP5Pt": false,
        "-NMWsAeOE7B-dN0IM4hB": true,
        "-NMWsFocKiGOujRVPvDH": true,
        "-NMWsKNU-Aog-4dEWy4C": false,
        "-NMWsQZwpzd3fInEnatg": false,
        "-NMWsVadx53rjMUu2VPR": true,
        "-NMWsZUJUzMoy3e4Jb2u": true,
        "-NMWschFkymGYs2AiZV1": true,
        "-NMWshpv-mz8sNZPlzuo": true,
        "-NMWsotwfXh9mjhaSm2i": true
      }
    }

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
}

export const writeUserHasSeenTutorial = (userId: string) => {

    const updates: any = {};
    updates['/users/' + userId + '/has_seen_tutorial'] = moment().tz('US/Pacific').format();

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
}

export const endFreeTrial = (userId: string) => {

    const updates: any = {};
    updates['/users/' + userId + '/subscription_status'] = "cancelled";

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
}

export const writeStudentSub = (userId: string) => {

    const updates: any = {};
    updates['/users/' + userId + '/subscription_status'] = "active";

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
}

export const writeFreeTrial = (userId: string) => {

    const updates: any = {};
    updates['/users/' + userId + '/subscription_status'] = "trial";
    updates['/users/' + userId + '/free_trial_started'] = moment.tz('US/Pacific').format();

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
}

export const readRecordingById = (recordingId:any, callback: any) => {
  return new Promise<any>(function (resolve, reject) {
    const recordingRef = ref(database, 'recordings/'+recordingId);

    onValue(recordingRef, (snapshot) => {
      callback(snapshot.val());
      resolve(null);
    }, {
      //onlyOnce: true
    });
  });
};

export const readFeaturedRecordings = (callback: any) => {
  const recordingsRef = ref(database, 'recordings');

  onValue(recordingsRef, (snapshot) => {
    var recordings:any[] = [];
    var i = 0;

    snapshot.forEach((childSnapshot) => {
      i++;

      const recordingId = childSnapshot.key;

      var recording = childSnapshot.val();

      if (!recording.isHidden){
        if (recording.isAvailable){
          recordings.push(recording);
        }
        else if (moment(recording.releasedOn).isAfter(moment().subtract(1, "months"))){
          recordings.push(recording);
        }
      }

      if(i >= snapshot.size) {
        recordings.sort((a, b) => (moment(a.releasedOn).isBefore(moment(b.releasedOn)) ? 1 : -1));
        callback(recordings);
      }
    });
  }, {
    //onlyOnce: true
  });
};

export function updateMatchToScoresConflict(match: any, playersAgreeOnScore: boolean){

  if (match.id){

    const updates: any = {};

    updates['/matches/' + match.id + '/playersAgreeOnScore/'] = playersAgreeOnScore;

    update(ref(database), updates).then((res) => {
      return(res);
    })
    .catch((error) => {
      console.log(error);
    });

  }
  else {
    return;
  }

}

export function countRecordInSplit(playerId:string, splitId:any, callback: any){

  const splitsMatchesRef = ref(database, '/splits/'+splitId+'/matches');

  var totalCount:number = 0;
  var winsCount:number = 0;
  var lossesCount:number = 0;

  onValue(splitsMatchesRef, (snapshot)=>{

    if (snapshot.val()){
      var matchCount:any = 0;
      var totalMatches: any = Object.keys(snapshot.val()).length;

      for(var matchId in snapshot.val()){
        var playerWon: boolean = true;
        var matchRef = ref(database, '/matches/'+matchId);

        matchCount++;
        onValue(matchRef, (match)=>{

           if (playerId in match.val().players && match.val().status == "done"){
             for (var player in match.val().players[playerId].score){
               if (match.val().players[playerId].score[playerId] < match.val().players[playerId].score[player]){
                 playerWon = false;
               }
             }

             if (playerWon){
               winsCount++;
             }
             else {
               lossesCount++;
             }
             totalCount++;
           }
           if (matchCount == totalMatches){
             callback({
               [playerId] : {
                 total: totalCount,
                 losses: lossesCount,
                 wins: winsCount
               }
             });
           }
        });
      }
    }
  });

}

export function countChallengesInSplit(playerId:string, opponentId:string, splitId:any, callback:any){
  const splitsMatchesRef = ref(database, '/splits/'+splitId+'/matches');

  var challengeCount:number = 0;

  onValue(splitsMatchesRef, (snapshot)=>{
    for(var matchId in snapshot.val()){
      var matchRef = ref(database, '/matches/'+matchId);

      onValue(matchRef, (match)=>{
         if (playerId in match.val().players && opponentId in match.val().players){
           challengeCount++;
         }
      });
    }

  });

  callback(challengeCount);

}

export function readUserChallengeMatches(userId: string, callback: any){

  const matchesRef = ref(database, '/matches/');

  var matches: any[] = [];

  onValue(matchesRef, (snapshot) => {
    var i = 0;

    snapshot.forEach((childSnapshot) => {
      i++;
      const matchId = childSnapshot.key;
      const match = childSnapshot.val();
      var weShouldAddMatch = false;

      for (var playerId in match.players){

        if (playerId == userId){
          weShouldAddMatch = true;
        }
      }

      if (match.status != "challenge"){
        weShouldAddMatch = false;
      }

      if(weShouldAddMatch){
        matches.push(childSnapshot.val());
      }

      if(i === snapshot.size) {
        matches.sort((a, b) => (moment(b.actual_time).isAfter(moment(a.actual_time)) ? 1 : -1));
        callback(matches);
      }
    });
  });
};

export async function findMatchTimesForPlayers(userId:string, opponents: string[], game:any, type:string, callback: any){
    var times:any = [];
    var timezones:string[] = [];

    times.push(await readUserAvailabilityTimes(userId));
    timezones.push(await readUserAvailabilityTimezone(userId));

    for (var i=0; i<opponents.length; i++){
      times.push(await readUserAvailabilityTimes(opponents[i]));
      timezones.push(await readUserAvailabilityTimezone(opponents[i]));
    }

    var matchingTimes:any[] = [];

    for (var i=1; i<times.length; i++){
      for (var opponentDay in times[i]){
        for (var opponentTime in times[i][opponentDay]){
          for (var playerDay in times[0]){
            for (var playerTime in times[0][playerDay]){
              var count = 0;
              if (times[0][playerDay][playerTime] && times[i][opponentDay][opponentTime]){
                var playerHours:any = playerTime.slice(0,2);
                var playerMinutes:any = playerTime.slice(-2);
                var opponentHours:any = opponentTime.slice(0,2);
                var opponentMinutes:any = opponentTime.slice(-2);
                var playerMoment:any = moment().day(playerDay).hours(playerHours).minutes(playerMinutes).tz(timezones[0]);
                var opponentMoment: any = moment().day(opponentDay).hours(opponentHours).minutes(opponentMinutes).tz(timezones[0]);
                if (playerMoment.isSame(opponentMoment)){
                  if (playerMoment.isBefore(moment())){
                    playerMoment = playerMoment.add(7, 'days');
                  }
                  matchingTimes.push(playerMoment.format());
                }
              }
            }
          }
        }
      }
    }

    matchingTimes = shuffle(matchingTimes);
    matchingTimes = matchingTimes.slice(0, 3);

    console.log("Matching times..."); //TODO - remove debugging
    console.log(matchingTimes); //TODO - remove debugging

    if (matchingTimes){
      callback(matchingTimes);
    }
    else {
      callback([]);
    }

};

export function writeUserIGN(userId: string, data:any, callback: any) {

  const updates: any = {};

  if (data.discordId){
    updates['/users/' + userId + '/discordId'] = data.discordId;
  }

  if (data.game){
    var gameName = data.game.replace(/\s/g, "");
    updates['/users/' + userId + '/igns/'+gameName] = data.ign;
  }

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
    callback(result);

  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export function writeUserGame(userId: string, name:string, value: boolean, callback: any) {

  const updates: any = {};

  if (name){
    updates['/users/' + userId + '/public/games/'+name+'/'] = value;
  }
  var result:any;

  get(child(ref(database), '/games/'+name+'/splitIds/')).then((snapshot)=>{
    if (snapshot.exists()){
      var splits = snapshot.val();
      //console.log(snapshot.val());
      for (var id in splits){
        if (splits[id]){
          updates['/splits/'+id+'/players/'+userId+'/'] = value;
          updates['/users/'+userId+'/splits/'+id+'/'] = value;
        }
      }
    }

    update(ref(database), updates).then((res) => {
      result = res;
      callback(result);
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });
  }).catch((error)=>{
    //console.log(error);
  });

  return result;
};

export const readSplitById = (splitId:string, callback: any) => {
  return new Promise<any>(function (resolve, reject) {
    const splitRef = ref(database, 'splits/'+splitId);

    onValue(splitRef, (snapshot) => {
      callback(snapshot.val());
      resolve(null);
    }, {
      //onlyOnce: true
    });
  });
};

export function writeUserCosmetics(userId: string, data:any, callback: any) {

  const updates: any = {};

  if (data.bannerId){
    updates['/users/' + userId + '/public/cosmetics/banner'] = data.bannerId;
  }

  if (data.pictureId){
    updates['/users/' + userId + '/public/cosmetics/picture'] = data.pictureId;
  }

  if (data.borderId){
    updates['/users/' + userId + '/public/cosmetics/border'] = data.borderId;
  }

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
    callback(result);

  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export const readBorders = (callback: any) => {
  const bordersRef = ref(database, 'cosmetics/borders');

  onValue(bordersRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export const readPictures = (callback: any) => {
  const picturesRef = ref(database, 'cosmetics/pictures');

  onValue(picturesRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export const readBanners = (callback: any) => {
  const bannersRef = ref(database, 'cosmetics/banners');

  onValue(bannersRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export const readGame = (gameName:string, callback: any) => {
  const gamesRef = ref(database, 'games/'+gameName+'/');

  onValue(gamesRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export const readGames = (callback: any) => {
  const gamesRef = ref(database, 'games');

  onValue(gamesRef, (snapshot) => {
    callback(snapshot.val());
  }, {
    //onlyOnce: true
  });
};

export const readUserFutureMatches = (userId: string, callback: any) => {
  const matchesRef = ref(database, 'users/' + userId + '/matches');

  var matches: any[] = [];

  var thereIsData = false;

  onValue(matchesRef, (snapshot) => {
    var i = 0;

    snapshot.forEach((childSnapshot) => {
      thereIsData = true;

      const matchId = childSnapshot.key;

      const matchRef = ref(database, 'matches/'+matchId);

      onValue(matchRef, (m) => {
        i++;
        var match = m.val();

        if (match == null){
          //console.log("Match is null: "+matchId); //TODO - remove debugging
        }
        else if (match.status == "matchmaking") {
          //console.log("Match is Skipped because it's in Matchmaking"); //TODO - remove debugging
        }
        else {
          var match_moment = moment(match.actual_time).tz(match.timezone);

          var match_index = -1;

          var found_match = matches.find(function(match_item, i){
            if(match_item.id === matchId){
              match_index = i;
              return i;
            }
          });

          if (match_index >= 0){
            matches[match_index] = m.val();
          }
          else {
            if (m.val().status && childSnapshot.val()){
              if (m.val().status != "done"){
                //Return matches in the future
                if (moment().isBefore(match_moment)){
                  matches.push(m.val());
                }
                //Return matches that are within 15 days in the past
                else if (moment().isAfter(match_moment) && moment().diff(match_moment, "days") <= 15){
                  matches.push(m.val());

                }
              }
            }
          }
        }

        if(i >= snapshot.size) {
          matches.sort((a, b) => (moment(b.actual_time).isBefore(moment(a.actual_time)) ? 1 : -1));
          callback(matches);
        }

      }, {
        //onlyOnce: true
      });
    });
    if (!thereIsData){
      callback(false);
    }
  }, {
    //onlyOnce: true
  });
};

export function writeUserInfo(userId: string, data:any, callback: any) {

  const updates: any = {};

  if (data.displayName){
    updates['/users/' + userId + '/displayName'] = data.displayName;
  }

  if (data.firstName){
    updates['/users/' + userId + '/firstName'] = data.firstName;
  }

  if (data.lastName){
    updates['/users/' + userId + '/lastName'] = data.lastName;
  }

  if (data.phone){
    updates['/users/' + userId + '/phone'] = data.phone;
  }

  if (data.discordId){
    updates['/users/' + userId + '/discordId'] = data.discordId;
  }

  if (data.ignmtga){
    updates['/users/' + userId + '/igns/MTGArena'] = data.ignmtga;
  }

  if (data.ignBattleNet){
    updates['/users/' + userId + '/igns/Hearthstone'] = data.ignBattleNet;
  }

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;

    callback(result);

  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  //console.log(result);
  return result;
};

export const readOpenMatchmakingMatches = (userId: string, callback: any) => {

  return new Promise<any>(async (resolve, reject) => {

    const matchesRef = ref(database, '/matches/');

    var matches: any[] = [];

    onValue(matchesRef, (snapshot) => {
      var i = 0;

      snapshot.forEach((childSnapshot) => {
        i++;
        const matchId = childSnapshot.key;
        const match = childSnapshot.val();
        var weShouldAddMatch = true;

        if (match == null){
          //console.log("Match is null: "+matchId); //TODO - remove debugging
          weShouldAddMatch = false;
        }

        for (var playerId in match.players){

          if (playerId != userId){
            weShouldAddMatch = false;
          }
        }

        if (match.status != "matchmaking"){
          weShouldAddMatch = false;
        }

        if(weShouldAddMatch){
          matches.push(childSnapshot.val());
        }

        if(i === snapshot.size) {
          matches.sort((a, b) => (moment(b.actual_time).isAfter(moment(a.actual_time)) ? 1 : -1));
          callback(matches);
          resolve(matches);
        }
      });

    }, {
      //onlyOnce: true //TODO - Reeenable this line
    });
  });
};

export function findSmartMatchFromCriteria(userId: any, findMatchStartTimeISO:string, findMatchEndTimeISO:string, findMatchGame:any, findMatchType:string){
  return new Promise<void>(async (resolve, reject) => {
    var times:any = {};
    times = await readUserAvailabilityTimes(userId);
    //console.log("Times..."); //TODO - remove debugging
    //console.log(times); //TODO - remove debugging

    var timezone:string = '';
    timezone = await readUserAvailabilityTimezone(userId);
    //console.log("Timezone..."); //TODO - remove debugging
    //console.log(timezone); //TODO - remove debugging

    await readUserMatchmakingMatches(userId, (m: any[])=>{
      var tempMatches:any = [];
      var foundMatch:boolean = false;
      var matchQualifies: boolean = true;

      m = shuffle(m);

      for (var i=0; i<m.length; i++){
        if (!foundMatch){

          if (!findMatchStartTimeISO  && findMatchEndTimeISO){
            if (moment(m[i].actual_time).isBefore(moment(findMatchEndTimeISO)) && m[i].gameName == findMatchGame.name && m[i].gameType == findMatchType) {
              matchQualifies = true;
            }
          }
          else if (!findMatchEndTimeISO && findMatchStartTimeISO){
            if (moment(m[i].actual_time).isAfter(moment(findMatchStartTimeISO)) && m[i].gameName == findMatchGame.name && m[i].gameType == findMatchType) {
              matchQualifies = true;
            }
          }
          else if (!findMatchStartTimeISO && !findMatchEndTimeISO){
            if (m[i].gameName == findMatchGame.name && m[i].gameType == findMatchType) {
              matchQualifies = true;
            }
          }
          else if (moment(m[i].actual_time).isAfter(moment(findMatchStartTimeISO)) && moment(m[i].actual_time).isBefore(moment(findMatchEndTimeISO)) && m[i].gameName == findMatchGame.name && m[i].gameType == findMatchType) {
            matchQualifies = true;
          }

          if (matchQualifies) {

            var match_moment_converted = moment(m[i].actual_time).tz(timezone);

            var match_day = match_moment_converted.day();
            var match_day_text = '';

            switch(match_day){
              case 0:
                match_day_text = 'Sundays';
                break;
              case 1:
                match_day_text = 'Mondays';
                break;
              case 2:
                match_day_text = 'Tuesdays';
                break;
              case 3:
                match_day_text = 'Wednesdays';
                break;
              case 4:
                match_day_text = 'Thursdays';
                break;
              case 5:
                match_day_text = 'Fridays';
                break;
              case 6:
                match_day_text = 'Saturdays';
                break;
            }

            var match_minutes:string = "00";
            var match_hours:string = "";
            var match_hour_num = match_moment_converted.hour();

            if (match_moment_converted.minutes() > 30){
              match_hour_num++;
            }
            match_hours = ""+match_hour_num;

            while (match_hours.length < 2) {
              match_hours = "0" + match_hours;
            }

            var match_time_text = match_hours + match_minutes;

            if (times[match_day_text][match_time_text]){
              tempMatches.push(m[i]);
              foundMatch = true;
              break;
            }
            else {
              //console.log("Match was not selected because it doesn't match your available times"); //TODO - remove debugging
            }
          }
          else {
            //TODO - remove all below debugging
          //  console.log("Match: "+m[i].id+" doesn't match because...");
            if (!moment(m[i].actual_time).isAfter(moment(findMatchStartTimeISO))){
              //console.log("Match is not after our start time. Match time: "+m[i].actual_time+" Start time: "+findMatchStartTimeISO);
            }
            if (!moment(m[i].actual_time).isBefore(moment(findMatchEndTimeISO))){
              //console.log("Match is not before our end time. Match time: "+m[i].actual_time+" End time: "+findMatchEndTimeISO);
            }
            if (m[i].gameName != findMatchGame.name){
              //console.log("Match game ("+m[i].gameName+") does not match our game criteria ("+findMatchGame.name+")");
            }
            if (m[i].gameType != findMatchType){
              //console.log("Match type ("+m[i].gameType+") does not match our game criteria ("+findMatchType+")");
            }
          }
        }
      }
      resolve(tempMatches);
    });

  });
};

function shuffle(array:any[]) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
};

export function updateMatchWithUser(userId:string, match: any){
  if (match.id){

    const updates: any = {};

    //console.log("Match you are accepting..."); //TODO - remove debugging
    //console.log(match); //TODO - remove debugging

    var data:any = {};

    var time = moment(match.actual_time).tz(match.timezone).format();

    //console.log(time);

    data["suggestedTime"] = time;
    data["isWinner"] = false;
    data["score"] = {};
    data["score"][userId] = 0;
    for (var playerId in match.players){
      if (playerId != userId){
        data["score"][playerId] = 0;
        updates['/matches/' + match.id +'/players/' + playerId + '/score/' + userId] = 0;
      }
    }
    data["status"] = "start";

    updates['/matches/' + match.id + '/players/' + userId] = data;
    updates['/users/' + userId + '/matches/' + match.id + '/'] = true;

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
  }
  else {
    //console.log("Match skipped because it is missing its ID");
    return;
  }
};

export const readUserMatchmakingMatches = (userId: string, callback: any) => {

  return new Promise<any>(async (resolve, reject) => {

    const matchesRef = ref(database, '/matches/');

    var matches: any[] = [];

    onValue(matchesRef, (snapshot) => {
      var i = 0;

      snapshot.forEach((childSnapshot) => {
        i++;
        const matchId = childSnapshot.key;
        const match = childSnapshot.val();
        var weShouldAddMatch = true;

        if (match == null){
          console.log("Match is null: "+matchId); //TODO - remove debugging
          weShouldAddMatch = false;
        }

        for (var playerId in match.players){

          if (playerId == userId){
            //console.log("Match will not be added..."); //TODO - Remove debugging
            //console.log(match.id); //TODO - Remove debugging
            weShouldAddMatch = false; //TODO - reenable this line
          }
        }

        if (match.status != "matchmaking"){
          weShouldAddMatch = false;
        }

        if(weShouldAddMatch){
          matches.push(childSnapshot.val());
        }

        if(i === snapshot.size) {
          matches.sort((a, b) => (moment(b.actual_time).isAfter(moment(a.actual_time)) ? 1 : -1));
          //console.log(matches); //TODO - remove debugging
          callback(matches);
          resolve(matches);
        }
      });

    }, {
      //onlyOnce: true //TODO - Reeenable this line
    });
  });
};

export const writeMatchmakingMatch = (userId:string, opponentId:string, match: any, splitId:string) => {

    console.log("Creating match for..."); // TODO - Remove debugging
    console.log("User ID: "+userId); // TODO - Remove debugging
    console.log("Opponent ID: "+opponentId); // TODO - Remove debugging
    console.log("Match..."); // TODO - Remove debugging
    console.log(match); // TODO - Remove debugging
    console.log("Split ID:"+splitId); // TODO - Remove debugging

    const newMatchKey = push(child(ref(database), '/matches/')).key;

    match.id = newMatchKey;

    var updates: any = {};
    updates['/matches/' + newMatchKey + '/'] = match;
    updates['/users/' + userId + '/matches/' + newMatchKey + '/'] = true;
    updates['/users/' + opponentId + '/matches/' + newMatchKey + '/'] = true;
    updates['/splits/' + splitId + '/matches/' + newMatchKey + '/'] = true;

    var result:any;

    update(ref(database), updates).then((res) => {
      console.log("Match created, result:"+res); // TODO - Remove debugging
      result = res;

      updates = {};
      updates['/users/' + userId + '/matches/' + res] = true;

    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;

};

export async function sendNotificationEmail(email: string, notification_type: string){

  var subject: string = "";
  var html: string = "";
  var text: string = "";

  switch(notification_type){
    case "propose-match-time":
      subject = "📆 Your Opponent Wants to Reschedule Your Match";
      html = "<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\" style=\"font-family:arial, 'helvetica neue', helvetica, sans-serif\"><head><meta charset=\"UTF-8\"><meta content=\"width=device-width, initial-scale=1\" name=\"viewport\"><meta name=\"x-apple-disable-message-reformatting\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><meta content=\"telephone=no\" name=\"format-detection\"><title>New message</title><!--[if (mso 16)]><style type=\"text/css\"> a {text-decoration: none;} </style><![endif]--><!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--><!--[if gte mso 9]><xml> <o:OfficeDocumentSettings> <o:AllowPNG></o:AllowPNG> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml><![endif]--><style type=\"text/css\">#outlook a { padding:0;}.es-button { mso-style-priority:100!important; text-decoration:none!important;}a[x-apple-data-detectors] { color:inherit!important; text-decoration:none!important; font-size:inherit!important; font-family:inherit!important; font-weight:inherit!important; line-height:inherit!important;}.es-desk-hidden { display:none; float:left; overflow:hidden; width:0; max-height:0; line-height:0; mso-hide:all;}[data-ogsb] .es-button { border-width:0!important; padding:10px 30px 10px 30px!important;}@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1, h2, h3, h1 a, h2 a, h3 a { line-height:120%!important } h1 { font-size:36px!important; text-align:left } h2 { font-size:26px!important; text-align:left } h3 { font-size:20px!important; text-align:left } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:36px!important; text-align:left } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important; text-align:left } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important; text-align:left } .es-menu td a { font-size:12px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:14px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:14px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:14px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class=\"gmail-fix\"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:inline-block!important } a.es-button, button.es-button { font-size:20px!important; display:inline-block!important } .es-adaptive table, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0!important } .es-m-p0r { padding-right:0!important } .es-m-p0l { padding-left:0!important } .es-m-p0t { padding-top:0!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } .es-m-p5 { padding:5px!important } .es-m-p5t { padding-top:5px!important } .es-m-p5b { padding-bottom:5px!important } .es-m-p5r { padding-right:5px!important } .es-m-p5l { padding-left:5px!important } .es-m-p10 { padding:10px!important } .es-m-p10t { padding-top:10px!important } .es-m-p10b { padding-bottom:10px!important } .es-m-p10r { padding-right:10px!important } .es-m-p10l { padding-left:10px!important } .es-m-p15 { padding:15px!important } .es-m-p15t { padding-top:15px!important } .es-m-p15b { padding-bottom:15px!important } .es-m-p15r { padding-right:15px!important } .es-m-p15l { padding-left:15px!important } .es-m-p20 { padding:20px!important } .es-m-p20t { padding-top:20px!important } .es-m-p20r { padding-right:20px!important } .es-m-p20l { padding-left:20px!important } .es-m-p25 { padding:25px!important } .es-m-p25t { padding-top:25px!important } .es-m-p25b { padding-bottom:25px!important } .es-m-p25r { padding-right:25px!important } .es-m-p25l { padding-left:25px!important } .es-m-p30 { padding:30px!important } .es-m-p30t { padding-top:30px!important } .es-m-p30b { padding-bottom:30px!important } .es-m-p30r { padding-right:30px!important } .es-m-p30l { padding-left:30px!important } .es-m-p35 { padding:35px!important } .es-m-p35t { padding-top:35px!important } .es-m-p35b { padding-bottom:35px!important } .es-m-p35r { padding-right:35px!important } .es-m-p35l { padding-left:35px!important } .es-m-p40 { padding:40px!important } .es-m-p40t { padding-top:40px!important } .es-m-p40b { padding-bottom:40px!important } .es-m-p40r { padding-right:40px!important } .es-m-p40l { padding-left:40px!important } .es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; max-height:inherit!important } }</style></head><body style=\"width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0\"><div class=\"es-wrapper-color\" style=\"background-color:#FAFAFA\"><!--[if gte mso 9]><v:background xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"t\"> <v:fill type=\"tile\" color=\"#fafafa\"></v:fill> </v:background><![endif]--><table class=\"es-wrapper\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;background-color:#FAFAFA\"><tr><td valign=\"top\" style=\"padding:0;Margin:0\"><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td class=\"es-info-area\" align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#FFFFFF\" align=\"center\"><tr><td align=\"left\" style=\"padding:20px;Margin:0\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td align=\"center\" style=\"padding:0;Margin:0;display:none\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-header\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top\"><tr><td align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-header-body\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#ffffff\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\"><tr><td align=\"left\" style=\"Margin:0;padding-top:10px;padding-bottom:10px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td class=\"es-m-p0r\" valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td style=\"padding:0;Margin:0;padding-bottom:20px;font-size:0px\" align=\"center\"><img src=\"https://esporter.win/wp-content/uploads/2022/06/logo-nobackground-500-cropped.png\" alt=\"Logo\" style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;font-size:12px\" title=\"Logo\" width=\"200\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#ffffff\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px\"><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-top:15px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td class=\"es-m-txt-c\" align=\"center\" style=\"padding:0;Margin:0;padding-top:15px;padding-bottom:15px\"><h1 style=\"Margin:0;line-height:55px;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-size:46px;font-style:normal;font-weight:bold;color:#333333\">Check Your Match Time</h1></td></tr><tr><td style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px;font-size:0px\" align=\"center\"><img src=\"https://esporter.win/wp-content/uploads/2022/06/Untitled-design2.png\" alt style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic\" height=\"358\"></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:24px;color:#333333;font-size:16px\">Your opponent has proposed a new time for your match! You can accept the new time, or you can propose your own.<br><br>If you need more coordination, contact your opponent in Discord and talk it out! You'll find their Discord ID in the match info. <br></p></td></tr></table></td></tr></table></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-bottom:10px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:separate;border-spacing:0px;border-radius:5px\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\"><tr><td align=\"center\" style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px\"><span class=\"es-button-border\" style=\"border-style:solid;border-color:#2CB543;background:#3d85c6;border-width:0px;display:inline-block;border-radius:6px;width:auto\"><a href=\"https://app.esporter.win/Matches\" class=\"es-button\" target=\"_blank\" style=\"mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:20px;border-style:solid;border-color:#3d85c6;border-width:10px 30px 10px 30px;display:inline-block;background:#3d85c6;border-radius:6px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:normal;font-style:normal;line-height:24px;width:auto;text-align:center;border-left-width:30px;border-right-width:30px\">Go to My Matches</a></span></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-bottom:10px;padding-top:20px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\">Got a question? <a target=\"_blank\" style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#5C68E2;font-size:14px;line-height:21px\" href=\"https://discord.gg/dbAHbsRcJf\">Reach out in our #help channel!</a></p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\"><br>Thanks,</p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\">The Esporter Team<br></p></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td class=\"es-info-area\" align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#FFFFFF\" align=\"center\"><tr><td align=\"left\" style=\"padding:20px;Margin:0\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td align=\"center\" style=\"padding:0;Margin:0;display:none\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table></td></tr></table></div></body></html>";

      text = "Your opponent has proposed a new time for your match! Go to https://app.esporter.win/Matches to accept the time or propose a different time. You can also communicate with your opponent via Discord. You'll find their Discord ID in your match info. You can always use the #help channel in our Discord for questions. \nThanks! \nThe Esporter Team";
    break;
    case "accept-match-time":
      subject = "📆 Your Match Has Been Rescheduled";
      html = "<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\" style=\"font-family:arial, 'helvetica neue', helvetica, sans-serif\"><head><meta charset=\"UTF-8\"><meta content=\"width=device-width, initial-scale=1\" name=\"viewport\"><meta name=\"x-apple-disable-message-reformatting\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><meta content=\"telephone=no\" name=\"format-detection\"><title>Your Match Has Been Rescheduled</title><!--[if (mso 16)]><style type=\"text/css\"> a {text-decoration: none;} </style><![endif]--><!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--><!--[if gte mso 9]><xml> <o:OfficeDocumentSettings> <o:AllowPNG></o:AllowPNG> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml><![endif]--><style type=\"text/css\">#outlook a { padding:0;}.es-button { mso-style-priority:100!important; text-decoration:none!important;}a[x-apple-data-detectors] { color:inherit!important; text-decoration:none!important; font-size:inherit!important; font-family:inherit!important; font-weight:inherit!important; line-height:inherit!important;}.es-desk-hidden { display:none; float:left; overflow:hidden; width:0; max-height:0; line-height:0; mso-hide:all;}[data-ogsb] .es-button { border-width:0!important; padding:10px 30px 10px 30px!important;}@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1, h2, h3, h1 a, h2 a, h3 a { line-height:120%!important } h1 { font-size:36px!important; text-align:left } h2 { font-size:26px!important; text-align:left } h3 { font-size:20px!important; text-align:left } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:36px!important; text-align:left } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important; text-align:left } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important; text-align:left } .es-menu td a { font-size:12px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:14px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:14px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:14px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class=\"gmail-fix\"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:inline-block!important } a.es-button, button.es-button { font-size:20px!important; display:inline-block!important } .es-adaptive table, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0!important } .es-m-p0r { padding-right:0!important } .es-m-p0l { padding-left:0!important } .es-m-p0t { padding-top:0!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } .es-m-p5 { padding:5px!important } .es-m-p5t { padding-top:5px!important } .es-m-p5b { padding-bottom:5px!important } .es-m-p5r { padding-right:5px!important } .es-m-p5l { padding-left:5px!important } .es-m-p10 { padding:10px!important } .es-m-p10t { padding-top:10px!important } .es-m-p10b { padding-bottom:10px!important } .es-m-p10r { padding-right:10px!important } .es-m-p10l { padding-left:10px!important } .es-m-p15 { padding:15px!important } .es-m-p15t { padding-top:15px!important } .es-m-p15b { padding-bottom:15px!important } .es-m-p15r { padding-right:15px!important } .es-m-p15l { padding-left:15px!important } .es-m-p20 { padding:20px!important } .es-m-p20t { padding-top:20px!important } .es-m-p20r { padding-right:20px!important } .es-m-p20l { padding-left:20px!important } .es-m-p25 { padding:25px!important } .es-m-p25t { padding-top:25px!important } .es-m-p25b { padding-bottom:25px!important } .es-m-p25r { padding-right:25px!important } .es-m-p25l { padding-left:25px!important } .es-m-p30 { padding:30px!important } .es-m-p30t { padding-top:30px!important } .es-m-p30b { padding-bottom:30px!important } .es-m-p30r { padding-right:30px!important } .es-m-p30l { padding-left:30px!important } .es-m-p35 { padding:35px!important } .es-m-p35t { padding-top:35px!important } .es-m-p35b { padding-bottom:35px!important } .es-m-p35r { padding-right:35px!important } .es-m-p35l { padding-left:35px!important } .es-m-p40 { padding:40px!important } .es-m-p40t { padding-top:40px!important } .es-m-p40b { padding-bottom:40px!important } .es-m-p40r { padding-right:40px!important } .es-m-p40l { padding-left:40px!important } .es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; max-height:inherit!important } }</style></head><body style=\"width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0\"><div class=\"es-wrapper-color\" style=\"background-color:#FAFAFA\"><!--[if gte mso 9]><v:background xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"t\"> <v:fill type=\"tile\" color=\"#fafafa\"></v:fill> </v:background><![endif]--><table class=\"es-wrapper\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;background-color:#FAFAFA\"><tr><td valign=\"top\" style=\"padding:0;Margin:0\"><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td class=\"es-info-area\" align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#FFFFFF\" align=\"center\"><tr><td align=\"left\" style=\"padding:20px;Margin:0\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td style=\"padding:0;Margin:0;display:none\" align=\"center\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-header\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top\"><tr><td align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-header-body\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#ffffff\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\"><tr><td align=\"left\" style=\"Margin:0;padding-top:10px;padding-bottom:10px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td class=\"es-m-p0r\" valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td style=\"padding:0;Margin:0;padding-bottom:20px;font-size:0px\" align=\"center\"><img src=\"https://esporter.win/wp-content/uploads/2022/06/logo-nobackground-500-cropped.png\" alt=\"Logo\" style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;font-size:12px\" title=\"Logo\" width=\"200\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#ffffff\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px\"><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-top:15px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td class=\"es-m-txt-c\" align=\"center\" style=\"padding:0;Margin:0;padding-top:15px;padding-bottom:15px\"><h1 style=\"Margin:0;line-height:43px;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-size:36px;font-style:normal;font-weight:bold;color:#333333\">Your Match Time Was Accepted</h1></td></tr><tr><td style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px;font-size:0px\" align=\"center\"><img src=\"https://esporter.win/wp-content/uploads/2022/06/Untitled-design2.png\" alt style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic\" height=\"358\"></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:24px;color:#333333;font-size:16px\">Your match has been rescheduled to the time that you proposed. Check it out in your matches dashboard. <br><br>If you need more coordination, contact your opponent in Discord and talk it out! You'll find their Discord ID in the match info.</p></td></tr></table></td></tr></table></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-bottom:10px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:separate;border-spacing:0px;border-radius:5px\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\"><tr><td align=\"center\" style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px\"><span class=\"es-button-border\" style=\"border-style:solid;border-color:#2CB543;background:#3d85c6;border-width:0px;display:inline-block;border-radius:6px;width:auto\"><a href=\"https://app.esporter.win/Matches\" class=\"es-button\" target=\"_blank\" style=\"mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:20px;border-style:solid;border-color:#3d85c6;border-width:10px 30px 10px 30px;display:inline-block;background:#3d85c6;border-radius:6px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:normal;font-style:normal;line-height:24px;width:auto;text-align:center;border-left-width:30px;border-right-width:30px\">Go to My Matches</a></span></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-bottom:10px;padding-top:20px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\">Got a question? <a target=\"_blank\" style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#5C68E2;font-size:14px;line-height:21px\" href=\"https://discord.gg/dbAHbsRcJf\">Reach out in our #help channel!</a></p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\"><br>Thanks,</p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\">The Esporter Team<br></p></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td class=\"es-info-area\" align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#FFFFFF\" align=\"center\"><tr><td align=\"left\" style=\"padding:20px;Margin:0\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td style=\"padding:0;Margin:0;display:none\" align=\"center\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table></td></tr></table></div></body></html>";

      text = "Your match time has been accepted! Go to https://app.esporter.win/Matches to see and manage your matches. You can also communicate with your opponent via Discord. You'll find their Discord ID in your match info. You can always use the #help channel in our Discord for questions. \nThanks! \nThe Esporter Team";
      break;
    case 'accept-score-request':
      subject = "✅ Please Confirm Your Score";

      html = "<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\"><html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns:o=\"urn:schemas-microsoft-com:office:office\" style=\"font-family:arial, 'helvetica neue', helvetica, sans-serif\"><head><meta charset=\"UTF-8\"><meta content=\"width=device-width, initial-scale=1\" name=\"viewport\"><meta name=\"x-apple-disable-message-reformatting\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><meta content=\"telephone=no\" name=\"format-detection\"><title>Confirm Your Score</title><!--[if (mso 16)]><style type=\"text/css\"> a {text-decoration: none;} </style><![endif]--><!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]--><!--[if gte mso 9]><xml> <o:OfficeDocumentSettings> <o:AllowPNG></o:AllowPNG> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml><![endif]--><style type=\"text/css\">#outlook a { padding:0;}.es-button { mso-style-priority:100!important; text-decoration:none!important;}a[x-apple-data-detectors] { color:inherit!important; text-decoration:none!important; font-size:inherit!important; font-family:inherit!important; font-weight:inherit!important; line-height:inherit!important;}.es-desk-hidden { display:none; float:left; overflow:hidden; width:0; max-height:0; line-height:0; mso-hide:all;}[data-ogsb] .es-button { border-width:0!important; padding:10px 30px 10px 30px!important;}@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1, h2, h3, h1 a, h2 a, h3 a { line-height:120%!important } h1 { font-size:36px!important; text-align:left } h2 { font-size:26px!important; text-align:left } h3 { font-size:20px!important; text-align:left } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:36px!important; text-align:left } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important; text-align:left } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important; text-align:left } .es-menu td a { font-size:12px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:14px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:14px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:14px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class=\"gmail-fix\"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:inline-block!important } a.es-button, button.es-button { font-size:20px!important; display:inline-block!important } .es-adaptive table, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0!important } .es-m-p0r { padding-right:0!important } .es-m-p0l { padding-left:0!important } .es-m-p0t { padding-top:0!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } .es-m-p5 { padding:5px!important } .es-m-p5t { padding-top:5px!important } .es-m-p5b { padding-bottom:5px!important } .es-m-p5r { padding-right:5px!important } .es-m-p5l { padding-left:5px!important } .es-m-p10 { padding:10px!important } .es-m-p10t { padding-top:10px!important } .es-m-p10b { padding-bottom:10px!important } .es-m-p10r { padding-right:10px!important } .es-m-p10l { padding-left:10px!important } .es-m-p15 { padding:15px!important } .es-m-p15t { padding-top:15px!important } .es-m-p15b { padding-bottom:15px!important } .es-m-p15r { padding-right:15px!important } .es-m-p15l { padding-left:15px!important } .es-m-p20 { padding:20px!important } .es-m-p20t { padding-top:20px!important } .es-m-p20r { padding-right:20px!important } .es-m-p20l { padding-left:20px!important } .es-m-p25 { padding:25px!important } .es-m-p25t { padding-top:25px!important } .es-m-p25b { padding-bottom:25px!important } .es-m-p25r { padding-right:25px!important } .es-m-p25l { padding-left:25px!important } .es-m-p30 { padding:30px!important } .es-m-p30t { padding-top:30px!important } .es-m-p30b { padding-bottom:30px!important } .es-m-p30r { padding-right:30px!important } .es-m-p30l { padding-left:30px!important } .es-m-p35 { padding:35px!important } .es-m-p35t { padding-top:35px!important } .es-m-p35b { padding-bottom:35px!important } .es-m-p35r { padding-right:35px!important } .es-m-p35l { padding-left:35px!important } .es-m-p40 { padding:40px!important } .es-m-p40t { padding-top:40px!important } .es-m-p40b { padding-bottom:40px!important } .es-m-p40r { padding-right:40px!important } .es-m-p40l { padding-left:40px!important } .es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; max-height:inherit!important } }</style></head><body style=\"width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0\"><div class=\"es-wrapper-color\" style=\"background-color:#FAFAFA\"><!--[if gte mso 9]><v:background xmlns:v=\"urn:schemas-microsoft-com:vml\" fill=\"t\"> <v:fill type=\"tile\" color=\"#fafafa\"></v:fill> </v:background><![endif]--><table class=\"es-wrapper\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;background-color:#FAFAFA\"><tr><td valign=\"top\" style=\"padding:0;Margin:0\"><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td class=\"es-info-area\" align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#FFFFFF\" align=\"center\"><tr><td align=\"left\" style=\"padding:20px;Margin:0\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td style=\"padding:0;Margin:0;display:none\" align=\"center\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-header\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top\"><tr><td align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-header-body\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#ffffff\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\"><tr><td align=\"left\" style=\"Margin:0;padding-top:10px;padding-bottom:10px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td class=\"es-m-p0r\" valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td style=\"padding:0;Margin:0;padding-bottom:20px;font-size:0px\" align=\"center\"><img src=\"https://esporter.win/wp-content/uploads/2022/06/logo-nobackground-500-cropped.png\" alt=\"Logo\" style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;font-size:12px\" title=\"Logo\" width=\"200\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#ffffff\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px\"><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-top:15px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td class=\"es-m-txt-c\" align=\"center\" style=\"padding:0;Margin:0;padding-top:15px;padding-bottom:15px\"><h1 style=\"Margin:0;line-height:55px;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-size:46px;font-style:normal;font-weight:bold;color:#333333\">Confirm Your Score<br></h1></td></tr><tr><td style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px;font-size:0px\" align=\"center\"><img src=\"https://esporter.win/wp-content/uploads/2022/08/Confirm-Your-Score-Email-Image-No-Background1.png\" alt style=\"display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic\" height=\"358\"></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:24px;color:#333333;font-size:16px\">The score on one of your matches conflicts with the score your opponent reported. They sent you this message to try to resolve it. Check out your matches to correct your score and close out your match.<br><br>If you need more coordination, contact your opponent in Discord and talk it out! You'll find their Discord ID in the match info.</p></td></tr></table></td></tr></table></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-bottom:10px;padding-left:20px;padding-right:20px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:separate;border-spacing:0px;border-radius:5px\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" role=\"presentation\"><tr><td align=\"center\" style=\"padding:0;Margin:0;padding-top:10px;padding-bottom:10px\"><span class=\"es-button-border\" style=\"border-style:solid;border-color:#2CB543;background:#3d85c6;border-width:0px;display:inline-block;border-radius:6px;width:auto\"><a href=\"https://app.esporter.win/Matches\" class=\"es-button\" target=\"_blank\" style=\"mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:20px;border-style:solid;border-color:#3d85c6;border-width:10px 30px 10px 30px;display:inline-block;background:#3d85c6;border-radius:6px;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-weight:normal;font-style:normal;line-height:24px;width:auto;text-align:center;border-left-width:30px;border-right-width:30px\">Go to My Matches</a></span></td></tr><tr><td align=\"left\" style=\"padding:0;Margin:0;padding-bottom:10px;padding-top:20px\"><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\">Got a question? <a target=\"_blank\" style=\"-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:underline;color:#5C68E2;font-size:14px;line-height:21px\" href=\"https://discord.gg/dbAHbsRcJf\">Reach out in our #help channel!</a></p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\"><br>Thanks,</p><p style=\"Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;font-size:14px\">The Esporter Team<br></p></td></tr></table></td></tr></table></td></tr></table></td></tr></table><table class=\"es-content\" cellspacing=\"0\" cellpadding=\"0\" align=\"center\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%\"><tr><td class=\"es-info-area\" align=\"center\" style=\"padding:0;Margin:0\"><table class=\"es-content-body\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px\" cellspacing=\"0\" cellpadding=\"0\" bgcolor=\"#FFFFFF\" align=\"center\"><tr><td align=\"left\" style=\"padding:20px;Margin:0\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td valign=\"top\" align=\"center\" style=\"padding:0;Margin:0;width:560px\"><table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px\"><tr><td style=\"padding:0;Margin:0;display:none\" align=\"center\"></td></tr></table></td></tr></table></td></tr></table></td></tr></table></td></tr></table></div></body></html>";

      text = "Confirm your score! Go to https://app.esporter.win/Matches to see and manage your matches. You can also communicate with your opponent via Discord. You'll find their Discord ID in your match info. You can always use the #help channel in our Discord for questions. \nThanks! \nThe Esporter Team";
    break;
    default:
      //console.log("Notification email not sent");
      return;
  }
  try {
    const docRef = await addDoc(collection(firestore_db, "mail"), {
      to: email,
      message: {
        subject: subject,
        html: html,
        text: text
      }
    });
    //console.log("Document written with ID: ", docRef.id);
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};

export function acceptOpponentSuggestedTime(match: any, time: any){
  if (match.id){
    const updates: any = {};

    //console.log(time); //TODO - remove debugging
    //console.log("TIME ^"); //TODO - remove debugging
    time = moment(time).tz(match.timezone).format();

    for (var playerId in match.players){
      updates['/matches/' + match.id + '/players/' + playerId + '/suggestedTime'] = time;
    }

    updates['/matches/' + match.id + '/actual_time'] = time;

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
  }
  else {
    //console.log("Match skipped because it is missing its ID");
    return;
  }
};

export function updateMatchWithUserSuggestedTime(userId:string, match: any, time: any){
  if (match.id){

    const updates: any = {};

    var data = match.players[userId];

    time = moment(time).tz(match.timezone).format();

    //console.log(time);

    data["suggestedTime"] = time;

    updates['/matches/' + match.id + '/players/' + userId] = data;

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
  }
  else {
    //console.log("Match skipped because it is missing its ID");
    return;
  }
};

export function updateUserNotification(userId: string, notification: any, status: string) {

  var path: string = "";
  var value: boolean = true;

  switch(status){
    case "read":
      path = "hasBeenRead";
      value = true;
      break;
    case "archived":
      path = "isArchived";
      value = true;
      break;
    case "unread":
      path = "hasBeenRead";
      value = false;
      break;
    case "unarchived":
      path = "isArchived";
      value = false;
      break;
    default:
      //console.log("Unexpected value for notification status");
      return;
  }

  const updates: any = {};
  updates['/notifications/' + userId + '/' + notification.id + '/' + path] = value;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export function writeUserNotification(userId: string, notification_type: string, description: string, type: string, url: string, title: string) {

  var imgUrl: string = '';
  var icon: string = '';

  switch(type){
    case "proposed-time":
      imgUrl = "https://esporter.win/wp-content/uploads/2022/06/AdobeStock_294756450-scaled.jpeg";
      icon = "calendarClear";
      break;
    default:
      imgUrl = "https://esporter.win/wp-content/uploads/2022/06/AdobeStock_295842588-scaled.jpeg";
      icon = "notificationsOutline";
      break;
  }

  const created_at: string = moment().utc().format();
  const newNotificationKey = push(child(ref(database), '/notifications/' + userId + '/')).key;


  var notification: any = {
    content: {
      description: description,
      imgUrl: imgUrl,
      title: title,
      url: url
    },
    createdAt: created_at,
    hasBeenRead: false,
    isArchived: false,
    ownerId: userId,
    id: newNotificationKey,
    icon: icon
  }

  const updates: any = {};
  updates['/notifications/' + userId + '/' + newNotificationKey + '/'] = notification;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export const readUserNotifications = (userId: string, callback: any) => {
  const notificationsRef = ref(database, 'notifications/' + userId);

  var notifications: any[] = [];

  onValue(notificationsRef, (snapshot) => {
    var i = 0;
    snapshot.forEach((childSnapshot) => {
      const notificationId = childSnapshot.key;

      const notificationRef = ref(database, 'notifications/'+userId+'/'+notificationId);

      onValue(notificationRef, (n) => {
        i++;
        var notification = n.val();

        if (!notification.isArchived){
          notifications.push(n.val());
        }


        if(i === snapshot.size) {
          notifications.sort((a, b) => (moment(b.createdAt).isAfter(moment(a.createdAt)) ? 1 : -1));
          callback(notifications);
        }

      }, {
        onlyOnce: true
      });
    });
  }, {
    onlyOnce: true
  });
};

export const readUserProfileById = (userId: string, callback: any) => {
    const profileRef = ref(database, 'users/'+userId); // TODO - change this to read from profiles and build out the profile structure so that data can be public and separate from the rest of the user record

    var listener = onValue(profileRef, (snapshot) => {
      var profile = snapshot.val();
      callback(profile);
    }, (error) => {
      console.log("Reading User Profile Failed: "+error);
    });

    return listener;
};

export const updateMatchWithUserScore = (userId:string, match: any, playerScore: any, opponentScore: any, winner: any) => {
  console.log("Update match function starting...");

  if (match.id){

    const updates: any = {};
    var isWinner = true;

    if (winner == "opponent"){
      isWinner = false;
    }

    for (var playerId in match.players) {
      for (var id in match.players[playerId].score){
        if (id == userId){
          match.players[playerId].score[id] = playerScore;

          if (playerScore > opponentScore){
            match.players[id].isWinner = true;
          }
          else {
            match.players[id].isWinner = false;
          }
        }
        else {
          match.players[playerId].score[id] = opponentScore;

          if (opponentScore > playerScore){
            match.players[id].isWinner = true;
          }
          else {
            match.players[id].isWinner = false;
          }
        }
      }
      match.players[playerId].status = "done";
    }

    updates['/matches/' + match.id + '/players/'] = match.players;
    updates['/matches/' + match.id + '/status/'] = "done";
    updates['/matches/' + match.id + '/playersAgreeOnScore/'] = true;

    update(ref(database), updates).then((res) => {
      return(res);
    })
    .catch((error) => {
      console.log(error);
    });

  }
  else {
    return;
  }

};

export const updateMatchStatus = (match: any, status: any, wasConceded?: boolean, userId?: any, playersAgreeOnScore?: boolean) => {
  if (typeof wasConceded === 'undefined'){
    wasConceded = false;
  }

  if (match.id){

    switch (status){
      case "start":
      case "awaiting":
      case "inProgress":
      case "done":

        break;
      default:
        status = "start";
        //console.log("Status came in as incorrect value");
        break;
    }

    const updates: any = {};
    updates['/matches/' + match.id + '/status'] = status;

    /*
      if we are updating the match because the game was conceded, we should:
      1. set that the match was conceded by our player
      2. update the status of the match to "done" for both players and also for the match
      3. update the winner to the opponent
      4. update the match to say that the players do agree on the score
    */
    if (wasConceded){
      if (typeof userId !== 'undefined'){
        updates['/matches/' + match.id + '/wasConcededBy'] = userId;
        for (var id in match.players){
          if (id != userId){
            updates['/matches/' + match.id + '/players/' + id + '/status'] = "done";
            updates['/matches/' + match.id + '/players/' + id + '/isWinner'] = true;
            updates['/matches/' + match.id + '/playersAgreeOnScore'] = true;
          }
        }
      }
    }
    else {
      if (playersAgreeOnScore != null){
        updates['/matches/' + match.id + '/playersAgreeOnScore'] = playersAgreeOnScore;
      }
    }

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
  }
  else {
    //console.log("Match skipped because it is missing its ID");
    return;
  }

};

export const updateMatchWithUserStatus = (userId:string, match: any, status: any) => {
  if (match.id){

    switch (status){
      case "start":
      case "awaiting":
      case "inProgress":
      case "done":
        break;
      default:
        status = "start";
        //console.log("Status came in as incorrect value");
        break;
    }

    const updates: any = {};
    updates['/matches/' + match.id + '/players/' + userId + '/status'] = status;

    var result:any;

    update(ref(database), updates).then((res) => {
      result = res;
    })
    .catch((error) => {
      console.log(error);
      result = "error";
    });

    return result;
  }
  else {
    //console.log("Match skipped because it is missing its ID");
    return;
  }

};

export const readUserMatchById = (matchId: string, callback: any) => {
  const matchRef = ref(database, 'matches/' + matchId);

  var match: any[] = [];

  onValue(matchRef, (snapshot) => {
    var match = snapshot.val();
    callback(match);
  });
};

export function readUserMatchHistory(userId: string, callback: any) {
  const matchesRef = ref(database, 'users/' + userId + '/matches');

  var matches: any[] = [];

  var thereIsData = false;

  onValue(matchesRef, (snapshot) => {
    var i = 0;

    snapshot.forEach((childSnapshot) => {
      thereIsData = true;
      const matchId = childSnapshot.key;

      const matchRef = ref(database, 'matches/'+matchId);

      onValue(matchRef, (m) => {
        i++;
        var match = m.val();

        if (match == null){
          //console.log("Match is null: "+matchId); //TODO - remove debugging
        }
        else if (match.status == "matchmaking") {
          //console.log("Match is in matchmaking: "+matchId); //TODO - remove debugging
        }
        else {
          var match_moment = moment(match.actual_time).tz(match.timezone);

          var match_index = -1;

          var found_match = matches.find(function(match_item, i){
            if(match_item.id === matchId){
              match_index = i;
              return i;
            }
          });

          if (match_index >= 0){
            matches[match_index] = m.val();
          }
          else {
            //[DEPRECATED] Only return matches in the past by more than 1 day
            //if (moment().isAfter(match_moment) && moment().diff(match_moment, "days") > 1){

            if (m.val().status && childSnapshot.val()){
              if (m.val().status == "done"){
                matches.push(m.val());
              }
            }
          }
        }

        if(i >= snapshot.size) {
          matches.sort((a, b) => (moment(b.actual_time).isAfter(moment(a.actual_time)) ? 1 : -1));
          //console.log(matches); //TODO - remove debugging
          callback(matches);
        }

      }, {
        //onlyOnce: true
      });
    });
    if (!thereIsData){
      callback(false);
    }
  }, {
    //onlyOnce: true
  });
};

export const readUserMatches = (userId: string, callback: any) => {
  const matchesRef = ref(database, 'users/' + userId + '/matches');

  var matches: any[] = [];

  var thereIsData = false;

  onValue(matchesRef, (snapshot) => {
    var i = 0;

    snapshot.forEach((childSnapshot) => {
      thereIsData = true;

      const matchId = childSnapshot.key;

      const matchRef = ref(database, 'matches/'+matchId);

      onValue(matchRef, (m) => {
        i++;
        var match = m.val();

        if (match == null){
          //console.log("Match is null: "+matchId); //TODO - remove debugging
        }
        else if (match.status == "matchmaking" || match.status== "challenge") {
          //console.log("Match is Skipped because it's in Matchmaking"); //TODO - remove debugging
        }
        else {
          var match_moment = moment(match.actual_time).tz(match.timezone);

          var match_index = -1;

          var found_match = matches.find(function(match_item, i){
            if(match_item.id === matchId){
              match_index = i;
              return i;
            }
          });

          if (match_index >= 0){
            matches[match_index] = m.val();
          }
          else {
            //Return matches in the future
            /*if (moment().isBefore(match_moment)){
              matches.push(m.val());
            }*/

            //[DEPRECATED] Return matches that are within 1 day in the past
            //if (moment().isAfter(match_moment) && moment().diff(match_moment, "days") <= 1){

            if (m.val().status && childSnapshot.val()){
              if (m.val().status != "done"){
                matches.push(m.val());
              }
            }
          }
        }

        if(i >= snapshot.size) {
          matches.sort((a, b) => (moment(b.actual_time).isBefore(moment(a.actual_time)) ? 1 : -1));
          //console.log(matches); //todo - remove debugging
          callback(matches);
        }

      }, {
        //onlyOnce: true
      });
    });
    if (!thereIsData){
      callback(false);
    }
  }, {
    //onlyOnce: true
  });
};

export function readUserAvailabilityTimezone(userId: string) {
  return new Promise<string>(function (resolve, reject) {
    const timezoneRef = ref(database, 'users/' + userId + '/availability');

    var timezone: any;

    onValue(timezoneRef, (snapshot) => {
      const data = snapshot.val();
      if (data && data.timezone){
        timezone = data.timezone;
        resolve(timezone);
      }
      else {
        timezone = moment.tz.guess();
        writeUserAvailabilityTimezone(userId, timezone);
        resolve(timezone);
      }
    });
  });
}

export function writeUserAvailabilityTimezone(userId: string, timezone: string) {
  const timezoneData = timezone;

  const updates: any = {};
  updates['/users/' + userId + '/availability/timezone'] = timezoneData;

  var result:any;

  update(ref(database), updates).then((res) => {
    result = res;
  })
  .catch((error) => {
    //console.log("User ID: "+userId); //TODO - Remove debugging
    //console.log("Timezone:"+timezone); //TODO - Remove debugging
    console.log(error);
    result = "error";
  });

  //console.log(result);
  return result;
};

export function readUserAvailabilityTimes(userId: string) {
  return new Promise<any>(function (resolve, reject) {
    const timesRef = ref(database, 'users/' + userId + '/availability/times');

    var timezone: any;

    onValue(timesRef, (snapshot) => {
      const data = snapshot.val();
      if (data){
        resolve(data);
      }
      else {
        console.log("There are no times");
        resolve({});
      }
    });
  });
}

export function writeUserAvailabilityTime(userId: string, day:string, time: string, value: boolean) {

  //console.log("Request Received - Day: "+day+" Time: "+time);
  const timeData = value;

  const updates: any = {};
  updates['/users/' + userId + '/availability/times/' + day + '/' + time] = timeData;

  var result:any;

   update(ref(database), updates).then((res) => {
    result = res;
  })
  .catch((error) => {
    console.log(error);
    result = "error";
  });

  return result;
};

export function getCurrentUser(){
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (u: any) => {
      if (u) {
        resolve(u);
      }
      else {
        reject(null);
      }
    });
    unsubscribe();
  });
};

export async function signInUserWithEmail(email: string, password: string){
  signInWithEmailAndPassword(auth, email, password).then((userCredential) => {
    const user = userCredential.user;
    //console.log(user);
  })
  .catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(errorCode, errorMessage);
  });
};

export function logoutUser(){
  return signOut(auth).then(() => {
    window.history.replaceState({}, '', '/Login');
    window.location.href = "/Login";
  }).catch((error) => {
    // An error happened.
    console.log(error);
  });
};

export {app, auth, user, database};
